// What this application is called, and who publishes it.
//
// THE APPLICATION IS NOT THE COMPANY. "Flexi Network" is the company that
// publishes the platform's applications. Customer-facing copy names the
// APPLICATION, so an operator who runs several of them can tell which one is
// asking them for something.
//
// FNP-1367 is why this file is required. FNP-1935 moved the navbar title here;
// before that it was typed inline and config/index.ts named the wrong product.
//
// Read the name from here. Never type it into a component.
const product = {
    // Machine name: the repo / package slug.
    name: 'flexinet-marketplace-app',

    // Customer-facing application name. This is the string that appears in
    // the navbar and in headings.
    displayName: 'Marketplace Console',

    // The company that publishes this application. Same for every app on
    // the platform — do not change this per app.
    publisher: 'Flexi Network',
};

export default product;
